import React from "react";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import cx from "classnames";

import Badge from "components/Badge";

import styles from "./SignUpForm.module.scss";

const HeaderLogo = dynamic(
  () => import("components/AppHeader/components/HeaderLogo"),
  { ssr: false }
);

type TOfferItem = {
  header: string;
  price: string;
  savings?: string;
};

const offersList: TOfferItem[] = [
  {
    header: "web_landing_page_pay_monthly",
    price: "web_landing_page_monthly_price",
  },
  {
    header: "web_landing_page_pay_annual",
    price: "web_landing_page_annual_price",
    savings: "web_landing_page_annual_price_save",
  },
];

const OfferListItem: React.FC<TOfferItem> = ({
  header,
  price: priceWithPeriod,
  savings,
}) => {
  const { t } = useTranslation("translations");
  const [price, period] = t(priceWithPeriod).split(" ");

  return (
    <div className={styles.offer}>
      {savings && (
        <Badge size="small" variant="primary" className={styles.savings}>
          {t(savings)}
        </Badge>
      )}
      <h3 className={styles.name}>{t(header)}</h3>
      <div className={styles.priceContainer}>
        <span className={styles.price}>{price}</span>
        <span className={styles.period}>{period}</span>
      </div>
    </div>
  );
};

export const SignUpContainer = ({ title }: { title?: string }) => {
  const [offer1, offer2] = offersList;
  return (
    <>
      <HeaderLogo className={styles.headerLogo} />
      <div className={styles.container}>
        <h2 className={styles.title}>{title}</h2>
        <div className={styles.offers}>
          <OfferListItem header={offer1.header} price={offer1.price} />
          <div className={cx(styles.divider)} />
          <OfferListItem
            header={offer2.header}
            price={offer2.price}
            savings={offer2.savings}
          />
        </div>
      </div>
    </>
  );
};
